import { useState, useRef, useCallback } from 'react';
import { Autocomplete } from '@react-google-maps/api';

export default function LocationPicker({ placeholder, value, onSelect }) {
  const [inputValue, setInputValue] = useState(value || '');
  const autocompleteRef = useRef(null);

  const onLoad = useCallback((autocomplete) => {
    autocompleteRef.current = autocomplete;
  }, []);

  const onPlaceChanged = () => {
    if (!autocompleteRef.current) return;
    const place = autocompleteRef.current.getPlace();
    if (!place.geometry) return;

    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();

    // Extract just the city/locality name for background corridor-matching logic
    let cityName = place.name;
    const components = place.address_components || [];
    const cityComponent =
      components.find(c => c.types.includes('locality')) ||
      components.find(c => c.types.includes('administrative_area_level_3')) ||
      components.find(c => c.types.includes('administrative_area_level_2'));
    if (cityComponent) cityName = cityComponent.long_name;

    const displayName = place.name + (place.formatted_address ? ', ' + place.formatted_address : '');
    setInputValue(place.name);

    onSelect({
      displayName: place.name,
      fullAddress: place.formatted_address || place.name,
      cityName: cityName,
      latitude: lat,
      longitude: lng,
    });
  };

  return (
    <Autocomplete
      onLoad={onLoad}
      onPlaceChanged={onPlaceChanged}
      options={{ componentRestrictions: { country: 'in' } }}
    >
      <input
        style={styles.input}
        placeholder={placeholder}
        value={inputValue}
        onChange={e => setInputValue(e.target.value)}
      />
    </Autocomplete>
  );
}

const styles = {
  input: {
    width: '100%', height: 44, borderRadius: 8, border: '1.5px solid #d9edfa',
    padding: '0 12px', fontSize: 14, boxSizing: 'border-box', fontFamily: 'inherit',
  },
};